import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileTabBar } from './MobileTabBar';
import { useUIStore } from '../../stores';
import { cn } from '../../utils';

export function Layout() {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed);
  const sidebarMobileOpen = useUIStore((state) => state.sidebarMobileOpen);
  const setSidebarMobileOpen = useUIStore((state) => state.setSidebarMobileOpen);
  const location = useLocation();

  useEffect(() => {
    setSidebarMobileOpen(false);
  }, [location.pathname, setSidebarMobileOpen]);

  useEffect(() => {
    document.body.classList.toggle('mobile-nav-open', sidebarMobileOpen);
    return () => document.body.classList.remove('mobile-nav-open');
  }, [sidebarMobileOpen]);

  return (
    <div className="min-h-screen bg-bg">
      {/* Header */}
      <Header />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main
        className={cn(
          'relative z-30 bg-bg',
          'pt-[56px] min-h-screen transition-all duration-normal',
          sidebarCollapsed ? 'ml-[64px]' : 'ml-[240px]',
          'max-lg:ml-0', // 移动端隐藏 sidebar margin
          'max-lg:pb-[56px]' // 移动端留出底部 tab bar 空间
        )}
      >
        <div className="p-4 md:p-6 max-w-7xl mx-auto animate-fade-in">
          <Outlet />
        </div>
      </main>

      {/* Mobile Bottom Tab Bar */}
      {!sidebarMobileOpen && <MobileTabBar />}

      {/* Mobile Sidebar Overlay */}
      {sidebarMobileOpen && (
        <div
          className="fixed inset-x-0 top-[56px] bottom-0 bg-black/45 z-40 max-lg:block hidden animate-fade-in"
          onClick={() => setSidebarMobileOpen(false)}
        />
      )}
    </div>
  );
}
